import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useContext, ReactNode } from 'react'
import { ThemeContext } from '../context/theme-context/ThemeContext'
import { lightTheme, darkTheme } from './mui-theme'

interface MuiThemeWrapperProps {
  children: ReactNode
}

function MuiThemeWrapper({ children }: MuiThemeWrapperProps) {
  const { theme } = useContext(ThemeContext)
  const muiTheme = theme === 'dark' ? darkTheme : lightTheme

  return (
    <ThemeProvider theme={muiTheme}>
      {children}
    </ThemeProvider>
  )
}

export default MuiThemeWrapper
